import { Dialog } from "@surya-digital/leo-reactjs-material-ui";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { ConfirmAllowedDomainDeletionDialogContent } from "./contents/ConfirmAllowedDomainDeletionDialogContent";
import { useDeleteAllowedDomainStore } from "../../stores/Hooks";
import { DeleteAllowedDomainRPC } from "@pulse/pulse-rpcs/lib/email-cycle/deleteAllowedDomainRPC";
import { useTranslation } from "react-i18next";
import { UnexpectedErrorDialog } from "../../../../components/dialogs/UnexpectedErrorDialog";

interface ConfirmAllowedDomainDeletionDialogProps {
  open: boolean;
  onClose: VoidFunction;
  onDomainNotFound: VoidFunction;
}

const CONFIRM_DELETE_DIALOG_WIDTH = "560px";

export const ConfirmAllowedDomainDeletionDialog: React.FC<ConfirmAllowedDomainDeletionDialogProps> =
  observer(({ open, onClose, onDomainNotFound }) => {
    const [openUnexpectedErrorDialog, setOpenUnexpectedErrorDialog] =
      useState(false);

    const { t } = useTranslation();
    const translate = t as unknown as (key: string) => string;
    const deleteAllowedDomainStore = useDeleteAllowedDomainStore();

    const handleAllowedDomainDeletion = async (): Promise<void> => {
      await deleteAllowedDomainStore
        .deleteAllowedDomain()
        .catch(() => setOpenUnexpectedErrorDialog(true));

      switch (deleteAllowedDomainStore.deleteAllowedDomainRPCError) {
        case null:
          onClose();
          break;
        case DeleteAllowedDomainRPC.RPCError.DomainNotFound:
          onDomainNotFound();
          break;
      }
    };

    return (
      <>
        <Dialog
          open={open}
          title={`${translate("emailCycles.allowedDomainsDeleteDomain")}?`}
          primaryButtonText={translate(
            "emailCycles.allowedDomainsDeleteDomain",
          )}
          primaryButtonColor="destructive"
          onPrimaryButtonClick={handleAllowedDomainDeletion}
          isPrimaryButtonDisabled={
            deleteAllowedDomainStore.loadingDeleteAllowedDomain
          }
          secondaryButtonText={t("common.cancel")}
          onSecondaryButtonClick={onClose}
          isSecondaryButtonDisabled={
            deleteAllowedDomainStore.loadingDeleteAllowedDomain
          }
          width={CONFIRM_DELETE_DIALOG_WIDTH}
          onClose={deleteAllowedDomainStore.resetStore}
          disableBackdropClick={true}
        >
          <ConfirmAllowedDomainDeletionDialogContent />
        </Dialog>

        {openUnexpectedErrorDialog && (
          <UnexpectedErrorDialog
            message={translate(
              "emailCycles.allowedDomainsDeleteUnexpectedErrorMessage",
            )}
            onClickDone={() => {
              setOpenUnexpectedErrorDialog(false);
              deleteAllowedDomainStore.resetStore();
            }}
          />
        )}
      </>
    );
  });
